import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FolderPic from '../../../../../../images/folder.svg';

const styles = (theme) => ({
    root: {
        position: 'relative',
        marginRight: 20,
        '& > svg': {
            width: 143,
            '@media (max-width: 1440px)': {
                width: 135,
            }
        }
    },
    folderContent: {
        position: 'absolute',
        bottom: 12,
        left: 12,
        color: '#fff',
        '@media (max-width: 1440px)': {
            bottom: 22
        }
    },
    folderTitle: {
        fontSize: 18,
    },
    folderValue: {
        fontSize: 13,
    },
    folderLabel: {
        fontSize: 10
    },
    parag: {
        margin: 0
    }
})

const Forlder = ({ classes, color, title, value, label }) => {
    return (
        <div className={classes.root}>
            <svg height="110" viewBox="0 0 143 110" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.585496" fill-rule="evenodd" clip-rule="evenodd" d="M37.3465 0.0693359H9.81744C4.60468 0.0693359 0.378906 4.29511 0.378906 9.50787V26.8704V31.5311V88.8894C0.378906 94.948 0.984493 97.2994 2.12462 99.5191L2.26991 99.7961C3.50381 102.103 5.31452 103.914 7.62171 105.148C9.83662 106.332 12.0343 106.985 17.7901 107.036L18.5284 107.039H124.594C130.652 107.039 133.004 106.433 135.224 105.293L135.501 105.148C137.808 103.914 139.619 102.103 140.852 99.7961C142.037 97.5812 142.69 95.3835 142.74 89.6277L142.743 88.8894V26.8704C142.743 20.8118 142.138 18.4604 140.998 16.2407L140.852 15.9637C139.619 13.6565 137.808 11.8458 135.501 10.6119C133.193 9.37797 130.905 8.72087 124.594 8.72087L47.729 8.72144L37.3465 0.0693359Z" fill="#1ACA95"/>
            <path opacity="0.458519" fill-rule="evenodd" clip-rule="evenodd" d="M0.376953 54.5315C9.26693 51.3227 20.8414 46.3118 35.5267 36.5228C43.5651 31.1645 43.632 22.5266 43.7087 12.6082C43.7264 10.3193 43.7447 7.96223 43.8615 5.56152L47.729 8.7844L124.592 8.78383C130.903 8.78383 133.191 9.44094 135.499 10.6748C137.806 11.9087 139.617 13.7194 140.85 16.0266L140.996 16.3037C142.136 18.5234 142.741 20.8748 142.741 26.9333V40.1384C140.626 45.4212 137.897 50.503 135.173 55.3049C134.33 56.7899 133.173 58.1218 132.021 59.4484L132.021 59.4486C130.145 61.6084 128.281 63.7542 127.805 66.5242C127.035 71.0043 127.627 75.5655 128.22 80.1358L128.22 80.136L128.22 80.1362C128.728 84.0479 129.236 87.9662 128.892 91.8459C128.296 98.5717 119.787 103.606 111.119 107.102H18.5264L17.7882 107.099C12.0324 107.048 9.83467 106.395 7.61976 105.211C5.31256 103.977 3.50186 102.166 2.26796 99.8591L2.12266 99.582C0.982539 97.3624 0.376953 95.0109 0.376953 88.9524V54.5315Z" fill="#1ACA95"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M116.252 45.1312C124.251 45.1312 130.736 38.6465 130.736 30.6471C130.736 22.6478 124.251 16.1631 116.252 16.1631C108.252 16.1631 101.768 22.6478 101.768 30.6471C101.768 38.6465 108.252 45.1312 116.252 45.1312Z" fill="#0EB683"/>
            <g opacity="0.80199">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M119.604 23.2725H112.898C111.787 23.2725 110.887 24.1731 110.887 25.2841V36.0131C110.887 37.1241 111.787 38.0247 112.898 38.0247H119.604C120.715 38.0247 121.616 37.1241 121.616 36.0131V25.2841C121.616 24.1731 120.715 23.2725 119.604 23.2725ZM112.228 25.2841C112.228 24.9138 112.528 24.6136 112.898 24.6136H119.604C119.974 24.6136 120.275 24.9138 120.275 25.2841V36.0131C120.275 36.3834 119.974 36.6836 119.604 36.6836H112.898C112.528 36.6836 112.228 36.3834 112.228 36.0131V25.2841Z" fill="white"/>
            <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="110" y="23" width="12" height="16">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M119.604 23.2725H112.898C111.787 23.2725 110.887 24.1731 110.887 25.2841V36.0131C110.887 37.1241 111.787 38.0247 112.898 38.0247H119.604C120.715 38.0247 121.616 37.1241 121.616 36.0131V25.2841C121.616 24.1731 120.715 23.2725 119.604 23.2725ZM112.228 25.2841C112.228 24.9138 112.528 24.6136 112.898 24.6136H119.604C119.974 24.6136 120.275 24.9138 120.275 25.2841V36.0131C120.275 36.3834 119.974 36.6836 119.604 36.6836H112.898C112.528 36.6836 112.228 36.3834 112.228 36.0131V25.2841Z" fill="white"/>
            </mask>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M113.57 32.525C113.57 34.0064 114.771 35.2072 116.253 35.2072C117.734 35.2072 118.935 34.0064 118.935 32.525C118.935 31.0437 117.734 29.8428 116.253 29.8428C114.771 29.8428 113.57 31.0437 113.57 32.525ZM117.593 32.5261C117.593 33.2668 116.992 33.8673 116.252 33.8673C115.511 33.8673 114.911 33.2668 114.911 32.5261C114.911 31.7855 115.511 31.185 116.252 31.185C116.992 31.185 117.593 31.7855 117.593 32.5261Z" fill="white"/>
            </g>
            </svg>

            <div className={classes.folderContent}>
                <span className={classes.folderTitle}>{title}</span>
                <p className={classes.parag}>
                    <span className={classes.folderValue}>{value}</span>{' '}
                    <span className={classes.folderLabel}>{label}</span>
                </p>
            </div>
        </div>
    )
}

export default withStyles(styles)(Forlder);